<template>
  <div>
    <!-- 头部导航 -->
    <div class="ls-card">
      <el-page-header @back="$router.go(-1)" content="设置支付方式" />
    </div>

    <div class="ls-card m-t-24 m-b-60">
      <div class="nr m-b-30 card-title">支付信息</div>
      <el-form :model="model" ref="modelRef" label-width="150px" size="small">
        <el-form-item
          v-for="(item, index) in paymentConfigData"
          :key="index"
          :label="item.name"
          :prop="item.key"
          :rules="{
            required: item.required,
            message: `请设置${item.name}`,
            trigger: 'blur',
          }"
        >
          <div v-if="item.type === 'text'">
            <el-input
              class="width-350"
              v-model="model[item.key]"
              :disabled="item.disabled ? true : false"
            />
          </div>
          <div v-if="item.type === 'image'">
            <material-select
              :limit="1"
              :disabled="false"
              v-model="model[item.key]"
            />
          </div>
          <div v-else-if="item.type === 'radio'">
            <div v-if="Object.keys(item.options).length == 1">
              <el-radio-group
                v-model="model[item.key]"
                :disabled="item.disabled ? true : false"
              >
                <el-radio
                  v-for="(radio, index) in item.options"
                  :key="index"
                  :label="index"
                >
                  {{ radio }}
                </el-radio>
              </el-radio-group>
            </div>
            <div v-else-if="Object.keys(item.options).length > 1">
              <el-radio-group
                v-model="model[item.key]"
                :disabled="item.disabled ? true : false"
              >
                <el-radio
                  v-for="(radio, index) in item.options"
                  :key="index"
                  :label="radio.value"
                >
                  {{ radio.label }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-else-if="item.type === 'number'">
            <el-input-number
              :disabled="item.disabled ? true : false"
              class="width-150"
              v-model="model[item.key]"
              :controls="false"
              :min="0"
            />
          </div>
          <div v-else-if="item.type === 'textarea'">
            <el-input
              class="width-350"
              type="textarea"
              :disabled="item.disabled ? true : false"
              v-model="model[item.key]"
              :controls="false"
              :min="0"
            />
          </div>
          <div v-if="item.tips" class="desc">{{ item.tips }}</div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 底部保存或取消 -->
    <div class="bg-white ls-fixed-footer">
      <div class="row-center flex m-t-15">
        <el-button size="small" @click="$router.go(-1)"> 取消 </el-button>
        <el-button size="small" type="primary" @click="onSubmit()">
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiSettingsPayConfigGetFrom,
  apiSettingsPayConfigSetConfig,
} from "@/api/setting";
import MaterialSelect from "@/components/material-select/index.vue";
export default {
  components: {
    MaterialSelect,
  },
  data() {
    return {
      id: 0,
      pay_way: 0,
      paymentConfigData: [],
      model: {},
    };
  },
  methods: {
    onSubmit() {
      this.$refs.modelRef.validate((valid) => {
        if (valid) {
          const api = this.id
            ? apiSettingsPayConfigSetConfig
            : apiSettingsPayConfigSetConfig;
          api({
            ...this.model,
            id: Number(this.id),
            pay_way: Number(this.pay_way),
          });
        }
      });
    },
    getForm() {
      apiSettingsPayConfigGetFrom({
        id: this.id,
        pay_way: this.pay_way,
      }).then((res) => {
        this.$set(this, "paymentConfigData", res);
        const model = {};
        const typeArr = res.map((v) => {
          return {
            key: v.key,
            value: v.value,
          };
        });
        typeArr.forEach((v) => {
          model[v.key] = v.value;
        });
        this.model = model;
      });
    },
  },
  created() {
    const { id, pay_way } = this.$route.query;
    this.id = id;
    this.pay_way = pay_way;
    this.getForm();
  },
};
</script>

<style lang="scss" scoped>
.width-150 {
  width: 150px;
}
.width-350 {
  width: 350px;
}
.ls-input {
  width: 280px;
}

.desc {
  color: #999999;
  display: block;
  height: 20px;
  line-height: 30px;
}

.copy {
  color: #4073fa;
  margin-left: 16px;
  cursor: pointer;
}
.card-title {
  font-size: 14px;
  font-weight: 500;
}
</style>
